import { APP_API_URL, MAIN_URL, MAIN_URL_SANY, OWN_DELIVERY_TYPE } from "../utils/constants";

class AppApi {
  // constructor({ baseUrl }) {
  //   MAIN_URL = baseUrl;
  // }

  _checkResponse(res) {
    if (res.ok) {
      return res.json();
    } else {
      const statusCode = res.status;
      return res.json().then((res) => {
        return Promise.reject({
          statusCode: statusCode,
          message: res.msg,
          detail: res.detail,
        });
      });
    }
  }

 

  updatePassword({
    password,
    token,
  }) {
    return fetch(`${APP_API_URL}/auth/forgot-password/change`, {
      method: "POST",
      // credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        password,
        token,
      }),
    }).then(this._checkResponse);
  }


}



const appApi = new AppApi({
  baseUrl: APP_API_URL,
});

export default appApi;
